import { render } from "./VideoUploadStatus.vue?vue&type=template&id=54da6769"
import script from "./VideoUploadStatus.vue?vue&type=script&lang=ts"
export * from "./VideoUploadStatus.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./VideoUploadStatus.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script